// extracted by mini-css-extract-plugin
export default {"phoneInputClass":"BasePhoneInput_phoneInputClass__j6jLL","phoneInputError":"BasePhoneInput_phoneInputError__Zi7LM","phoneDropdownError":"BasePhoneInput_phoneDropdownError__uIwYb"};